import React from 'react';
import { FaEdit, FaTrash, FaUserShield, FaUser } from 'react-icons/fa';

const AdminsTable = ({ admins, onEdit, onDelete, showRole = false, showSubDistrict = false }) => {
    return (
        <div className="bg-white rounded-3xl border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.02)] overflow-hidden">
            {/* Desktop Table View */}
            <div className="hidden md:block overflow-x-auto no-scrollbar">
                <table className="w-full text-left">
                    <thead>
                        <tr className="bg-slate-50/50 border-b border-slate-50">
                            <th className="px-10 py-5 text-[10px] font-black text-slate-400 uppercase tracking-widest">Administrator Identity</th>
                            <th className="px-10 py-5 text-[10px] font-black text-slate-400 uppercase tracking-widest">Email Contact</th>
                            {showRole && <th className="px-10 py-5 text-[10px] font-black text-slate-400 uppercase tracking-widest">Auth Level</th>}
                            {showSubDistrict && <th className="px-10 py-5 text-[10px] font-black text-slate-400 uppercase tracking-widest">Operational Sector</th>}
                            <th className="px-10 py-5 text-[10px] font-black text-slate-400 uppercase tracking-widest">Unit Affiliate</th>
                            <th className="px-10 py-5 text-[10px] font-black text-slate-400 uppercase tracking-widest text-right">Operations</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-50">
                        {admins.length === 0 ? (
                            <tr>
                                <td colSpan={4 + (showRole ? 1 : 0) + (showSubDistrict ? 1 : 0)} className="px-10 py-12 text-center text-slate-400 font-bold uppercase tracking-widest text-[10px]">
                                    No administrative personnel detected
                                </td>
                            </tr>
                        ) : (
                            admins.map((admin) => (
                                <tr key={admin.id} className="hover:bg-slate-50/50 transition-colors group">
                                    <td className="px-10 py-6">
                                        <div className="flex items-center gap-4">
                                            <div className="w-10 h-10 rounded-2xl bg-slate-50 flex items-center justify-center text-slate-400 group-hover:bg-white group-hover:text-indigo-600 transition-all border border-transparent group-hover:border-slate-100 shadow-sm">
                                                <FaUserShield size={14} />
                                            </div>
                                            <span className="text-sm font-black text-slate-900 uppercase tracking-tight">{admin.name}</span>
                                        </div>
                                    </td>
                                    <td className="px-10 py-6 text-xs font-bold text-slate-400">{admin.email}</td>
                                    {showRole && (
                                        <td className="px-10 py-6">
                                            <span className="inline-block bg-white border border-slate-100 text-slate-900 text-[9px] px-3 py-1 rounded-lg font-black uppercase tracking-widest shadow-sm">
                                                {admin.role.replace('_', ' ')}
                                            </span>
                                        </td>
                                    )}
                                    {showSubDistrict && <td className="px-10 py-6 text-xs font-bold text-slate-500 uppercase tracking-widest">{admin.sub_district_name || '-'}</td>}
                                    <td className="px-10 py-6 text-xs font-black text-slate-900 uppercase tracking-tighter">{admin.club_name || '-'}</td>
                                    <td className="px-10 py-6 text-right">
                                        <div className="flex justify-end gap-3 opacity-0 group-hover:opacity-100 transition-opacity">
                                            <button
                                                onClick={() => onEdit(admin)}
                                                className="w-10 h-10 rounded-xl bg-slate-50 text-indigo-600 flex items-center justify-center hover:bg-indigo-600 hover:text-white transition-all shadow-sm"
                                            >
                                                <FaEdit size={14} />
                                            </button>
                                            <button
                                                onClick={() => onDelete(admin.id)}
                                                className="w-10 h-10 rounded-xl bg-rose-50 text-rose-600 flex items-center justify-center hover:bg-rose-600 hover:text-white transition-all shadow-sm"
                                            >
                                                <FaTrash size={14} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Mobile Grid View */}
            <div className="md:hidden divide-y divide-slate-50 px-6">
                {admins.length === 0 ? (
                    <div className="py-12 text-center text-slate-400 font-bold uppercase tracking-widest text-[10px]">
                        No administrative personnel detected
                    </div>
                ) : (
                    admins.map((admin) => (
                        <div key={admin.id} className="py-8 space-y-4">
                            <div className="flex justify-between items-start">
                                <div>
                                    <div className="font-black text-slate-900 uppercase tracking-tight">{admin.name}</div>
                                    <div className="text-[10px] text-slate-400 font-bold uppercase mt-1">{admin.email}</div>
                                    {showRole && (
                                        <div className="inline-block bg-slate-50 border border-slate-100 text-slate-900 text-[9px] px-2 py-0.5 rounded-lg font-black uppercase tracking-widest mt-2">
                                            {admin.role.replace('_', ' ')}
                                        </div>
                                    )}
                                </div>
                                <div className="bg-slate-50 border border-slate-100 px-4 py-2 rounded-2xl text-center shadow-sm">
                                    <div className="text-[9px] font-black text-slate-400 uppercase tracking-widest mb-0.5">Unit</div>
                                    <div className="text-xs font-black text-slate-900 uppercase tracking-tight">{admin.club_name || '-'}</div>
                                </div>
                            </div>
                            <div className="flex justify-end gap-3 pt-4">
                                <button onClick={() => onEdit(admin)} className="px-6 py-3 bg-slate-50 text-slate-900 rounded-xl text-[10px] font-black uppercase tracking-widest border border-slate-100">Modify</button>
                                <button onClick={() => onDelete(admin.id)} className="px-6 py-3 bg-rose-50 text-rose-600 rounded-xl text-[10px] font-black uppercase tracking-widest border border-rose-100">Erase</button>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default AdminsTable;

